import { Box, BoxProps } from '@razorpay/blade/components';
import React, { PropsWithChildren, ReactNode } from 'react';

const ComponentSection: React.FC<BoxProps> = ({ children,...boxProps }) => {
  return (
    <Box display={'flex'} flexDirection={'column'} gap={'spacing.7'} {...boxProps}>
      {children}
    </Box>
  );
};

export default ComponentSection;
